import AirBankLogo from 'assets/psd2/AIRBANK.svg?react';
import CreditasBankLogo from 'assets/psd2/CREDITAS.svg?react';
import CSASBankLogo from 'assets/psd2/CSAS.svg?react';
import CSOBBankLogo from 'assets/psd2/CSOB.svg?react';
import DefaultBankLogo from 'assets/psd2/gray_bank.svg?react';
import EQUABankLogo from 'assets/psd2/EQUA.svg?react';
import FIOBankLogo from 'assets/psd2/FIO.svg?react';
import JTBankLogo from 'assets/psd2/JTB.svg?react';
import KBBankLogo from 'assets/psd2/KB.svg?react';
import MBankLogo from 'assets/psd2/MBANK.svg?react';
import MonetaBankLogo from 'assets/psd2/MONETA.svg?react';
import RaiffeisenBankLogo from 'assets/psd2/RAIFFEISEN.svg?react';
import PartnersBankLogo from 'assets/psd2/PARTNERS.svg?react';
import UniBankLogo from 'assets/psd2/UNI.svg?react';

type BankLogo = {
  logo: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  label: string;
};

export const BANK_LOGOS: Record<string, BankLogo> = {
  KB: {
    logo: KBBankLogo,
    label: 'Komerční banka',
  },
  CSOB: {
    logo: CSOBBankLogo,
    label: 'ČSOB',
  },
  CSAS: {
    logo: CSASBankLogo,
    label: 'Česká spořitelna',
  },
  CREDITAS: {
    logo: CreditasBankLogo,
    label: 'Creditas',
  },
  MONETA: {
    logo: MonetaBankLogo,
    label: 'MONETA Money Bank',
  },
  AIRBANK: {
    logo: AirBankLogo,
    label: 'Air Bank',
  },
  JTB: {
    logo: JTBankLogo,
    label: 'J&T Banka',
  },
  FIO: {
    logo: FIOBankLogo,
    label: 'Fio banka',
  },
  RAIFFEISEN: {
    logo: RaiffeisenBankLogo,
    label: 'Raiffeisenbank',
  },
  EQUA: {
    logo: EQUABankLogo,
    label: 'Equa bank',
  },
  MBANK: {
    logo: MBankLogo,
    label: 'mBank',
  },
  UNICREDIT: {
    logo: UniBankLogo,
    label: 'UniCredit',
  },
  PARTNERS: {
    logo: PartnersBankLogo,
    label: 'Partners Banka',
  },
};

export default BANK_LOGOS;

export const defaultBankLogo = DefaultBankLogo;
